import { AppConfig } from "@/app.config";
import store from "@/store";

export const convertDateIntoAmericanFormat = (date) => {
  let objectInitialDate = new Date(date);
  let day = objectInitialDate.getDate();
  let month = objectInitialDate.getMonth() + 1;
  let year = objectInitialDate.getFullYear();
  if (day < 10) {
    day = `0${day}`;
  }
  if (month < 10) {
    month = `0${month}`;
  }
  return `${month}/${day}/${year}`;
};

export const setDateHoursToMidNight = (date) => {
  return new Date(date).setHours(0, 0, 0);
};

export const setDateHoursToBeforeMidNight = (date) => {
  return new Date(date).setHours(23, 59, 59);
};

export const showAvailableEventDates = (
  date,
  allEvents,
  currentEvents,
  tab
) => {
  const currentCalendarDate = setDateHoursToMidNight(date);
  let showDate = true;
  allEvents.map((element) => {
    const firstEventDate = setDateHoursToMidNight(element.eventDateStart);
    const lastEventDate = setDateHoursToBeforeMidNight(element.eventDateEnd);
    if (
      currentCalendarDate >= firstEventDate &&
      currentCalendarDate < lastEventDate
    ) {
      if (
        tab === "editEventTab" &&
        element.eventKey === currentEvents.eventKey
      ) {
        showDate = true;
        return;
      }
      showDate = false;
    }
  });
  return showDate;
};

export const getEventByDate = (date, allEvents) => {
  const parsedDate = new Date(date);
  for (let value of allEvents) {
    const firstEventDate = setDateHoursToMidNight(value.eventDateStart);
    const lastEventDate = setDateHoursToBeforeMidNight(value.eventDateEnd);
    if (parsedDate >= firstEventDate && parsedDate < lastEventDate) {
      return value;
    }
  }
};

// date picker returning available days with promo events
export const datePickerTimelineOptionsFn = (
  date,
  firstEventDate,
  lastEventDate
) => {
  const calendarDates = new Date(date);
  const firstDate = setDateHoursToMidNight(firstEventDate);
  const lastDate = setDateHoursToBeforeMidNight(lastEventDate);
  return calendarDates >= firstDate && calendarDates < lastDate;
};

export const adminApi = async () => {
  const arenaEnv = store.getters["selectEnv/getEnv"];
  if (AppConfig.currentAdminEnv === "development") {
    return AppConfig.adminStageApiUrl;
  } else {
    return arenaEnv === "stage"
      ? AppConfig.adminStageApiUrl
      : AppConfig.adminProdApiUrl;
  }
};

export const sortStringsStartingWithNumbers = async (arr) => {
  arr.sort((a, b) => {
    const aIsNumber = /^\d/.test(a);
    const bIsNumber = /^\d/.test(b);

    if (aIsNumber && bIsNumber) {
      return parseInt(a) - parseInt(b);
    } else if (aIsNumber) {
      return -1;
    } else if (bIsNumber) {
      return 1;
    } else {
      return a.localeCompare(b);
    }
  });

  return arr;
};

export const isDateInThePast = (date) => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  yesterday.setHours(23, 59, 59, 999);
  return date < yesterday;
}

const hasEventOverlap = (promo, currentDate, currentEvent) => {
  if (currentEvent?.eventKey === promo.eventKey) {
    return false;
  }

  const promoStartDate = new Date(promo.eventDateStart);
  const promoEndDate = new Date(promo.eventDateEnd);

  const hasOverlap =
    currentDate >= promoStartDate &&
    currentDate <= promoEndDate &&
    promo.gameIDs.some((id) => currentEvent?.gameIDs.includes(id));

  return hasOverlap;
}

// Conditions to show/disable the dates in the datepicker
export const getFreeEventDates = (currentEvent, promoList) => (
  (date) => {
    const currentDate = new Date(date);

    if (
      isDateInThePast(currentDate) ||
      currentEvent?.stats === "closed"
    ) {
      return false;
    }

    const hasOverlap = promoList?.some((promo) =>
      hasEventOverlap(promo, currentDate, currentEvent)
    );

    return !hasOverlap;
  }
)
